import type { SfxDef, SfxId } from './types';

/** Frequências base (notas musicais aproximadas) */
const N = {
  C4: 261.63, D4: 293.66, E4: 329.63, F4: 349.23, G4: 392.0, A4: 440.0, B4: 493.88,
  C5: 523.25, D5: 587.33, E5: 659.25, F5: 698.46, G5: 783.99, A5: 880.0, B5: 987.77,
  C6: 1046.5, E6: 1318.51,
  C3: 130.81, A3: 220.0, E3: 164.81,
  C2: 65.41, A2: 110.0,
};

const SFX: Record<SfxId, SfxDef> = {
  // Pickup / item collected: blip ascendente fofo
  feed: {
    id: 'feed',
    category: 'sfx',
    totalDurationMs: 200,
    notes: [
      { freq: N.C5, durationMs: 60, type: 'sine', attackMs: 5, releaseMs: 30, gain: 0.3 },
      { freq: N.E5, durationMs: 60, type: 'sine', startOffsetMs: 50, attackMs: 5, releaseMs: 30, gain: 0.3 },
      { freq: N.G5, durationMs: 90, type: 'sine', startOffsetMs: 100, attackMs: 5, releaseMs: 50, gain: 0.3 },
    ],
  },
  // Play: arpeggio cute 3 notas
  play: {
    id: 'play',
    category: 'sfx',
    totalDurationMs: 280,
    notes: [
      { freq: N.G4, durationMs: 70, type: 'triangle', attackMs: 3, releaseMs: 30, gain: 0.3 },
      { freq: N.B4, durationMs: 70, type: 'triangle', startOffsetMs: 80, attackMs: 3, releaseMs: 30, gain: 0.3 },
      { freq: N.D5, durationMs: 100, type: 'triangle', startOffsetMs: 160, attackMs: 3, releaseMs: 50, gain: 0.3 },
    ],
  },
  // Clean: sweep ruído curto
  clean: {
    id: 'clean',
    category: 'sfx',
    totalDurationMs: 250,
    noiseAmount: 0.5,
    notes: [
      { freq: N.C4, durationMs: 200, type: 'sawtooth', attackMs: 5, releaseMs: 100, filterFreq: 800, gain: 0.15 },
    ],
  },
  // Discipline: nota grave seca
  discipline: {
    id: 'discipline',
    category: 'sfx',
    totalDurationMs: 150,
    notes: [
      { freq: N.A2, durationMs: 100, type: 'square', attackMs: 2, releaseMs: 60, gain: 0.3 },
      { freq: N.E3, durationMs: 80, type: 'square', startOffsetMs: 40, attackMs: 2, releaseMs: 40, gain: 0.2 },
    ],
  },
  // Heal: chime descendente
  heal: {
    id: 'heal',
    category: 'sfx',
    totalDurationMs: 350,
    notes: [
      { freq: N.G5, durationMs: 80, type: 'sine', attackMs: 5, releaseMs: 50, gain: 0.3 },
      { freq: N.E5, durationMs: 90, type: 'sine', startOffsetMs: 80, attackMs: 5, releaseMs: 60, gain: 0.3 },
      { freq: N.C5, durationMs: 120, type: 'sine', startOffsetMs: 170, attackMs: 5, releaseMs: 80, gain: 0.3 },
      { freq: N.G4, durationMs: 100, type: 'sine', startOffsetMs: 250, attackMs: 5, releaseMs: 80, gain: 0.2 },
    ],
  },
  // Attack: ruído curto + nota
  attack: {
    id: 'attack',
    category: 'sfx',
    totalDurationMs: 120,
    noiseAmount: 0.4,
    notes: [
      { freq: N.A3, durationMs: 80, type: 'square', attackMs: 1, releaseMs: 40, filterFreq: 1500, gain: 0.25 },
    ],
  },
  // Hit: nota grave + tremolo
  hit: {
    id: 'hit',
    category: 'sfx',
    totalDurationMs: 200,
    noiseAmount: 0.2,
    notes: [
      { freq: N.C3, durationMs: 150, type: 'square', attackMs: 1, releaseMs: 80, gain: 0.3 },
      { freq: N.E3, durationMs: 100, type: 'square', startOffsetMs: 30, attackMs: 1, releaseMs: 60, gain: 0.2 },
    ],
  },
  // Enemy die: glissando descendente
  'enemy-die': {
    id: 'enemy-die',
    category: 'sfx',
    totalDurationMs: 300,
    notes: [
      { freq: N.A4, durationMs: 250, type: 'sawtooth', attackMs: 3, releaseMs: 150, gain: 0.2 },
      { freq: N.A3, durationMs: 200, type: 'sawtooth', startOffsetMs: 100, attackMs: 3, releaseMs: 100, gain: 0.15 },
    ],
  },
  // Pickup: blip duplo agudo
  pickup: {
    id: 'pickup',
    category: 'sfx',
    totalDurationMs: 150,
    notes: [
      { freq: N.E5, durationMs: 50, type: 'sine', attackMs: 2, releaseMs: 30, gain: 0.3 },
      { freq: N.E6, durationMs: 60, type: 'sine', startOffsetMs: 60, attackMs: 2, releaseMs: 40, gain: 0.3 },
    ],
  },
  // Breeding: arpeggio longo ascendente brilhante
  breeding: {
    id: 'breeding',
    category: 'sfx',
    totalDurationMs: 800,
    notes: [
      { freq: N.C4, durationMs: 80, type: 'triangle', attackMs: 5, releaseMs: 50, gain: 0.25 },
      { freq: N.E4, durationMs: 80, type: 'triangle', startOffsetMs: 100, attackMs: 5, releaseMs: 50, gain: 0.25 },
      { freq: N.G4, durationMs: 80, type: 'triangle', startOffsetMs: 200, attackMs: 5, releaseMs: 50, gain: 0.25 },
      { freq: N.C5, durationMs: 80, type: 'triangle', startOffsetMs: 300, attackMs: 5, releaseMs: 50, gain: 0.25 },
      { freq: N.E5, durationMs: 80, type: 'triangle', startOffsetMs: 400, attackMs: 5, releaseMs: 50, gain: 0.25 },
      { freq: N.G5, durationMs: 80, type: 'triangle', startOffsetMs: 500, attackMs: 5, releaseMs: 50, gain: 0.25 },
      { freq: N.C6, durationMs: 200, type: 'triangle', startOffsetMs: 600, attackMs: 5, releaseMs: 100, gain: 0.3 },
    ],
  },
  // Death: glissando descendente longo
  death: {
    id: 'death',
    category: 'sfx',
    totalDurationMs: 700,
    notes: [
      { freq: N.E5, durationMs: 250, type: 'sawtooth', attackMs: 5, releaseMs: 150, gain: 0.2 },
      { freq: N.C5, durationMs: 250, type: 'sawtooth', startOffsetMs: 200, attackMs: 5, releaseMs: 150, gain: 0.2 },
      { freq: N.G4, durationMs: 250, type: 'sawtooth', startOffsetMs: 400, attackMs: 5, releaseMs: 150, gain: 0.2 },
      { freq: N.C3, durationMs: 250, type: 'sawtooth', startOffsetMs: 550, attackMs: 5, releaseMs: 150, gain: 0.2 },
    ],
  },
  // Tantrum: square com pitch errático
  tantrum: {
    id: 'tantrum',
    category: 'sfx',
    totalDurationMs: 250,
    notes: [
      { freq: N.A3, durationMs: 60, type: 'square', attackMs: 2, releaseMs: 30, gain: 0.25 },
      { freq: N.D4, durationMs: 60, type: 'square', startOffsetMs: 70, attackMs: 2, releaseMs: 30, gain: 0.25 },
      { freq: N.A3, durationMs: 60, type: 'square', startOffsetMs: 140, attackMs: 2, releaseMs: 30, gain: 0.25 },
    ],
  },
  // Levelup: arpeggio ascendente brilhante
  levelup: {
    id: 'levelup',
    category: 'sfx',
    totalDurationMs: 500,
    notes: [
      { freq: N.C5, durationMs: 80, type: 'triangle', attackMs: 3, releaseMs: 40, gain: 0.3 },
      { freq: N.E5, durationMs: 80, type: 'triangle', startOffsetMs: 100, attackMs: 3, releaseMs: 40, gain: 0.3 },
      { freq: N.G5, durationMs: 80, type: 'triangle', startOffsetMs: 200, attackMs: 3, releaseMs: 40, gain: 0.3 },
      { freq: N.C6, durationMs: 200, type: 'triangle', startOffsetMs: 300, attackMs: 3, releaseMs: 100, gain: 0.35 },
    ],
  },
  // Mutation: arpeggio mais shimery
  mutation: {
    id: 'mutation',
    category: 'sfx',
    totalDurationMs: 600,
    notes: [
      { freq: N.G5, durationMs: 100, type: 'sine', attackMs: 5, releaseMs: 60, gain: 0.25 },
      { freq: N.B5, durationMs: 100, type: 'sine', startOffsetMs: 120, attackMs: 5, releaseMs: 60, gain: 0.25 },
      { freq: N.E6, durationMs: 250, type: 'sine', startOffsetMs: 240, attackMs: 5, releaseMs: 150, gain: 0.3, detune: 5 },
    ],
  },
  // UI sounds — simples
  click: {
    id: 'click',
    category: 'sfx',
    totalDurationMs: 50,
    notes: [{ freq: N.A4, durationMs: 30, type: 'square', attackMs: 1, releaseMs: 15, gain: 0.15 }],
  },
  'modal-open': {
    id: 'modal-open',
    category: 'sfx',
    totalDurationMs: 120,
    notes: [
      { freq: N.G4, durationMs: 50, type: 'sine', attackMs: 2, releaseMs: 30, gain: 0.2 },
      { freq: N.D5, durationMs: 70, type: 'sine', startOffsetMs: 50, attackMs: 2, releaseMs: 40, gain: 0.2 },
    ],
  },
  'modal-close': {
    id: 'modal-close',
    category: 'sfx',
    totalDurationMs: 120,
    notes: [
      { freq: N.D5, durationMs: 50, type: 'sine', attackMs: 2, releaseMs: 30, gain: 0.2 },
      { freq: N.G4, durationMs: 70, type: 'sine', startOffsetMs: 50, attackMs: 2, releaseMs: 40, gain: 0.2 },
    ],
  },
  // Ovo chacoalhando: tiquinho seco (madeira/casca)
  'egg-wiggle': {
    id: 'egg-wiggle',
    category: 'sfx',
    totalDurationMs: 120,
    noiseAmount: 0.3,
    notes: [
      { freq: N.A3, durationMs: 40, type: 'square', attackMs: 1, releaseMs: 25, filterFreq: 1200, gain: 0.18 },
      { freq: N.C4, durationMs: 40, type: 'square', startOffsetMs: 55, attackMs: 1, releaseMs: 25, filterFreq: 1200, gain: 0.15 },
    ],
  },
  // Eclosão: crack + chime alegre
  hatch: {
    id: 'hatch',
    category: 'sfx',
    totalDurationMs: 600,
    noiseAmount: 0.4,
    notes: [
      { freq: N.A3, durationMs: 60, type: 'square', attackMs: 1, releaseMs: 30, filterFreq: 1500, gain: 0.2 },
      { freq: N.C4, durationMs: 60, type: 'square', startOffsetMs: 70, attackMs: 1, releaseMs: 30, filterFreq: 1500, gain: 0.18 },
      { freq: N.E5, durationMs: 90, type: 'triangle', startOffsetMs: 200, attackMs: 4, releaseMs: 50, gain: 0.25 },
      { freq: N.G5, durationMs: 90, type: 'triangle', startOffsetMs: 320, attackMs: 4, releaseMs: 50, gain: 0.25 },
      { freq: N.C6, durationMs: 180, type: 'triangle', startOffsetMs: 440, attackMs: 4, releaseMs: 100, gain: 0.3 },
    ],
  },
};

export function getSfxDef(id: SfxId): SfxDef {
  return SFX[id];
}

export function allSfxIds(): SfxId[] {
  return Object.keys(SFX) as SfxId[];
}
